import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";

export default function RutaProtegida({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <div style={{ padding: 20 }}>Cargando...</div>;
  if (!isAuthenticated) return <Navigate to="/sesion" replace />;

  return children;
}